import React, { useState, useEffect } from 'react';
import CustomNavBar from '../../../Commons/CustomNavBar';
import './styles.scss';


const Header = () => {
  const [onScrolling, setOnScrolling] = useState(false);

  // Setea la variable CSS con la altura real del header
  useEffect(() => {
    const setNavbarHeight = () => {
      const el = document.querySelector('.navbar-wrapper');
      if (el) {
        document.documentElement.style.setProperty('--navbar-height', el.offsetHeight + 'px');
      }
    };
    setNavbarHeight();
    window.addEventListener('resize', setNavbarHeight);
    return () => {
      window.removeEventListener('resize', setNavbarHeight);
    };
  }, []);

  const handleScroll = () => {
    if (window.scrollY > 20) {
      setOnScrolling(true);
    } else {
      setOnScrolling(false);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div className={ `navbar-wrapper ${onScrolling ? 'scrolling' : ''}` }>
      <CustomNavBar />
    </div>
  );
};

export default Header;
